module.exports = __webpack_public_path__ + "static/media/no_signup_white.6f489e96.svg";